<template>
  <div id="reportChart">
    <!--<div class="titleReport flex-wrap flex-vc flex-pc">
      <div class="blueIcon"></div>
      <div class="titleName">全部日程</div>
    </div>-->
    <div class="contentReport">
      <pieChartComponent id="pieChart" className="pie" :option="chartOption"></pieChartComponent>
    </div>
  </div>
</template>
<script>
import pieChartComponent from './pieChartComponent.vue'
export default {
  name: 'reportChartComponent',
  components: {
    pieChartComponent
  },
  props: {
    dataPie: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    chartOption () {
      let resultOption = {
        backgroundColor: 'white',
        legend: {
          orient: 'vertical',
          top: '15%',
          right: '15%',
          icon: 'circle',
          // data: [ '项目日程', '通知日程', '请假日程', '出差日程', '生活日程' ],
          data: [],
          textStyle: {
            fontSize: 14,
            padding: 3
          }
        },
        series: [
          {
            name: '全部日程统计',
            type: 'pie',
            radius: ['60%', '90%'],
            center: ['35%', '50%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: 'center'
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '30',
                  fontWeight: 'bold'
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              // {value: 335, name: '项目日程', itemStyle: {color: '#498BFF'}},
              // {value: 310, name: '通知日程', itemStyle: {color: '#FFAD49'}},
              // {value: 234, name: '请假日程', itemStyle: {color: '#FE6366'}},
              // {value: 135, name: '出差日程', itemStyle: {color: '#EED239'}},
              // {value: 1548, name: '生活日程', itemStyle: {color: '#52B94F'}}
            ]
          }
        ]
      }
      this.dataPie.forEach(function (v, index) {
        resultOption.legend.data[index] = v.category_name + ' ' + v.count
        resultOption.series[0].data[index] = {value: v.count, name: v.category_name + ' ' + v.count, itemStyle: {color: v.color}}
      })
      return resultOption
    }
  }
}
</script>
<style lang="stylus" scoped>
#reportChart{
  .titleReport{
    background $white
    .blueIcon{
      margin 0 1rem 0 0.625rem
      width 0.625rem
      height @width
      border-radius (@width/2)
      background $blue
    }
    .titleName{
      color $pepperGrey
    }
  }
  .contentReport{
    //height 10.5rem
    background $darkGrey
  }
}
</style>



// WEBPACK FOOTER //
// src/pagesPc/others/reportChartComponent.vue